import { useEffect, useReducer, useState } from "react";
import { AuthContext } from "./auth/authContext";
import { authReducer } from "./auth/authReducer";
import MyRoutes from "./router/MyRoutes";
import TagManager from "react-gtm-module";
import CryptoJS from "crypto-js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function App() {
  const tagManagerArgs = {
    gtmId: "GTM-WJFJMQZ",
  };

  TagManager.initialize(tagManagerArgs);

  // Inicialización del estado de autenticación
  const init = () => {
    const encryptedUser = localStorage.getItem(
      "IxSTUOSGGHxIGGUOSTSHpRkapsVuWEjFPtMogVWXLpTUKIznQNnGYy"
    );

    if (encryptedUser) {
      const userDecrypt = CryptoJS.AES.decrypt(
        encryptedUser,
        process.env.REACT_APP_CRYPT_KEY
      );
      return JSON.parse(userDecrypt.toString(CryptoJS.enc.Utf8));
    }
    return {
      logged: false,
    };
  };

  const [user, dispatch] = useReducer(authReducer, {}, init);

  useEffect(() => {
    if (user.logged) {
      const encryptedUser = CryptoJS.AES.encrypt(
        JSON.stringify(user),
        process.env.REACT_APP_CRYPT_KEY
      ).toString();
      localStorage.setItem(
        "IxSTUOSGGHxIGGUOSTSHpRkapsVuWEjFPtMogVWXLpTUKIznQNnGYy",
        encryptedUser
      );
    }
  }, [user]);

  // === Servicio de actualización del Service Worker ===
  // Estados para controlar la notificación de actualización
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  // Escuchamos el evento personalizado "swUpdated"
  useEffect(() => {
    const handleSWUpdate = (event) => {
      // Se espera que el event.detail contenga el SW en espera
      setUpdateAvailable(true);
      setWaitingWorker(event.detail);
    };

    window.addEventListener("swUpdated", handleSWUpdate);
    return () => {
      window.removeEventListener("swUpdated", handleSWUpdate);
    };
  }, []);

  // Función que envía el mensaje al SW en espera para que omita la espera y recarga la página
  const handleUpdate = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
      // Se recarga la página para que el nuevo SW tome el control
      window.location.reload();
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        dispatch,
      }}
    >
      {updateAvailable && (
        <div
          className="update-banner"
          style={{
            background: "#ffc107",
            padding: "10px",
            textAlign: "center",
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 1000,
          }}
        >
          <p style={{ margin: 0 }}>
            ¡Nueva versión disponible!{" "}
            <button
              onClick={handleUpdate}
              style={{
                marginLeft: "10px",
                padding: "5px 10px",
                border: "none",
                background: "#007bff",
                color: "#fff",
                cursor: "pointer",
                borderRadius: "4px",
              }}
            >
              Actualizar
            </button>
          </p>
        </div>
      )}
      <div style={{ paddingTop: updateAvailable ? "60px" : "0" }}>
        <MyRoutes />
      </div>
    </AuthContext.Provider>
  );
}

export default App;
